import React, { Component } from 'react';
import { useNavigate, NavLink, useParams } from 'react-router-dom';
import { Table, Button, notification, DatePicker, Select } from 'antd';
import { DownloadOutlined, LineChartOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
import { AuthContext } from 'context/AuthContext';
import reportService from 'services/report.service';
import branchService from 'services/branch.service';
import { formatDateForClient, formatDateForServer, formatMoney } from 'helpers/utils';
import { storage } from 'helpers';
import download from 'js-file-download';
import reportTypes from 'helpers/reportTypes';
import 'antd/dist/reset.css';

const { RangePicker } = DatePicker;
const { Option } = Select;

const EodReportByMerchWrapper = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  return <EodReportByMerch {...props} params={params} navigate={navigate} />;
};

class EodReportByMerch extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      reports: [],
      loading: false,
      startDate: storage.get('date-filters')
        ? storage.get('date-filters').startDate
        : formatDateForClient(dayjs().subtract(365, 'days')),
      endDate: storage.get('date-filters')
        ? storage.get('date-filters').endDate
        : formatDateForClient(),
      selectedBranch: '0',
      currentMerch: context?.selectedMerch,
      branches: [],
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Şube ID</div>,
          // title:<div style={tableTitleBold.titleBold}>"Şube ID"</div>,
          dataIndex: 'BranchId',
          key: 'BranchId',
          align: 'center',
          width: 100,
          render: (text, row) => {
            return (
              <span className="table-title-calibri-bold-12">
                {row.BranchId ? row.BranchId : ''}
              </span>
            );
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">Şube Adı</div>,
          dataIndex: 'BranchName',
          key: 'BranchName',
          align: 'center',
          width: 100,
          render: (text, row) => {
            return (
              <span className="table-title-calibri-bold-12">
                {row.BranchName ? row.BranchName : ''}
              </span>
            );
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">Toplam Gün Sonu Tutarı</div>,
          dataIndex: 'Amount',
          key: 'Amount',
          align: 'center',
          width: 100,
          render: (text, row) => {
            return (
              <div className="text-align-center">
                <span className="table-title-calibri-bold-12">{`${formatMoney(row.TotalEodAmount)} TL`}</span>
              </div>
            );
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">Gün Sonu Rapor Tarihi</div>,
          dataIndex: 'EodDate',
          key: 'EodDate',
          align: 'center',
          width: 120,
          render: (text, row) => {
            return (
              <span className="table-title-calibri-bold-12">
                {row.EodDate ? dayjs(row.EodDate).format('DD.MM.YYYY') : ''}
              </span>
            );
          },
        },
        {
          title: <div style={{ textAlign: 'center' }}>İşlemler</div>,
          dataIndex: 'actions',
          key: 'actions',
          align: 'center',
          fixed: 'right',
          width: 250,
          render: (text, row) => (
            <div style={{ textAlign: 'center' }}>
              <NavLink
                target="_blank"
                to={`/raporlar/terminal-bazli-gun-sonu-raporu/${row.BranchId}/${row.TerminalNumber}`}
                state={{
                  startDate: this.state?.startDate,
                  endDate: this.state?.endDate,
                }}
              >
                <Button className="mr-3" type="primary">
                  <LineChartOutlined />
                  <span>Terminal Raporları</span>
                </Button>
              </NavLink>
            </div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getReports();
    this.getCurrentMerchBranches();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getReports();
      this.getCurrentMerchBranches();
    }
  }

  getReports = (currentPage, pageSize) => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      try {
        const { currentMerch, endDate, startDate, selectedBranch } = this.state;
        if (currentMerch?.number) {
          const { payload } = await reportService.getEodReportsByMerch(
            currentMerch?.number,
            formatDateForServer(startDate),
            formatDateForServer(endDate),
            selectedBranch,
            currentPage,
            pageSize,
          );
          this.setState({ loading: false, reports: payload });
        }
      } catch (error) {
        this.setState({ loading: false, reports: [] });
        notification.error({
          message: 'İşlem Başarısız',
          description: error?.message || String(error),
        });
      }
    });
  };

  getCurrentMerchBranches = async () => {
    try {
      await this.setState({ loading: true, currentMerch: this.context?.selectedMerch });
      const number = this.context?.selectedMerch?.number;
      if (number) {
        const { payload } = await branchService.getBranchesByMerch(number);
        this.setState({ loading: false, branches: payload });
      }
    } catch (error) {
      this.setState({ loading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error?.message || String(error),
      });
    }
  };

  onDateChange = (dates) => {
    if (!dates || dates.length !== 2) return;
    const startDate = formatDateForClient(dates[0]);
    const endDate = formatDateForClient(dates[1]);
    this.setState({ startDate, endDate }, () => {
      storage.set({ startDate, endDate }, 'date-filters');
      this.getReports();
    });
  };

  onBranchChange = (selectedBranch) => {
    if (!selectedBranch) {
      // eslint-disable-next-line no-param-reassign
      selectedBranch = 0;
    }
    this.setState({ selectedBranch }, () => {
      storage.set({ selectedBranch }, 'branch-filters');
      this.getReports();
    });
  };

  renderBranchOptions = () => {
    const { branches } = this.state;
    return branches?.map((branch) => (
      <Option key={branch.BranchId} value={branch.BranchId}>
        {branch.BranchTitle}
      </Option>
    ));
  };

  downloadExcel = async () => {
    try {
      this.setState({ downloading: true });
      const { currentMerch, startDate, endDate, selectedBranch } = this.state;
      const data = await reportService.getEodReportsExcel(
        currentMerch?.number,
        reportTypes.EOD_BY_BRANCH,
        selectedBranch,
        0,
        formatDateForServer(startDate),
        formatDateForServer(endDate),
      );
      download(
        data,
        `SubeBazindaGunSonuOzet-${currentMerch?.number}-${dayjs().format('DD-MM-YYYY')}.xls`,
      );
      this.setState({ downloading: false });
    } catch (error) {
      this.setState({ loading: false, downloading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error?.message || String(error),
      });
    }
  };

  downloadAllExcel = async () => {
    try {
      this.setState({ downloading: true });
      const { currentMerch, startDate, endDate, selectedBranch } = this.state;
      const data = await reportService.getEodReportsExcel(
        currentMerch?.number,
        reportTypes.EOD_BY_MERCHANT,
        selectedBranch,
        0,
        formatDateForServer(startDate),
        formatDateForServer(endDate),
      );
      download(
        data,
        `SubeBazindaGunSonuDetay-${currentMerch?.number}-${dayjs().format('DD-MM-YYYY')}.xls`,
      );
      this.setState({ downloading: false });
    } catch (error) {
      this.setState({ loading: false, downloading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  render() {
    const { reports, columns, loading, currentMerch, startDate, endDate, downloading } = this.state;
    return (
      <>
        <PageContainer
          style={{ paddingBottom: 0 }}
          title="Şube Bazında Günsonu Raporu"
          extra={[
            <RangePicker
              allowClear={false}
              defaultValue={[dayjs(startDate, 'DD.MM.YYYY'), dayjs(endDate, 'DD.MM.YYYY')]}
              key="eod"
              onChange={this.onDateChange}
              format="DD.MM.YYYY"
            />,
            <Select
              key="branch"
              loading={loading}
              defaultValue={null}
              onChange={this.onBranchChange}
              style={{ width: 200 }}
            >
              <Option value={null} key="ALL">
                Tüm Şubeler
              </Option>
              {this.renderBranchOptions()}
            </Select>,
            <Button
              loading={downloading}
              disabled={loading || downloading}
              key="downloadAll"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={async () => {
                await this.downloadAllExcel();
              }}
            >
              Tüm İşlemleri İndir
            </Button>,
            <Button
              loading={downloading}
              disabled={loading || downloading}
              key="download"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={async () => {
                await this.downloadExcel();
              }}
            >
              İndir
            </Button>,
          ]}
        />
        <PageContainer
          style={{ paddingTop: 0 }}
          title=""
          subTitle={`${currentMerch?.number} ${currentMerch?.type}'li şube bazlı günsonu raporu listelenmektedir.`}
        >
          <Table
            loading={loading}
            dataSource={reports}
            columns={columns}
            pagination
            rowKey={(record, index) => index}
            onChange={(page) => {
              this.getReports(page.current, page.pageSize);
            }}
          />
        </PageContainer>
      </>
    );
  }
}

EodReportByMerch.contextType = AuthContext;

export default EodReportByMerchWrapper;
